import logger from '@/utils/logger';

/**
 * Development logging utility to reduce console noise
 * Use this instead of console.log for development-specific logging
 */

const isDevelopment = process.env.NODE_ENV === 'development';

// Toggle these flags as needed for debugging specific areas
const DEBUG_FLAGS = {
  IMPERSONATION: false,
  PROFILES: false,
  AUTH: false,
  DATABASE: false,
  ALL: false // Master switch to enable all logging
};

export const devLog = {
  impersonation: (...args: unknown[]) => {
    if (isDevelopment && (DEBUG_FLAGS.IMPERSONATION || DEBUG_FLAGS.ALL)) {
      logger.info('[IMPERSONATION]', ...args);
    }
  },

  profiles: (...args: unknown[]) => {
    if (isDevelopment && (DEBUG_FLAGS.PROFILES || DEBUG_FLAGS.ALL)) {
      logger.info('[PROFILES]', ...args);
    }
  },

  users: (...args: unknown[]) => {
    if (isDevelopment && (DEBUG_FLAGS.PROFILES || DEBUG_FLAGS.ALL)) {
      logger.info('[USERS]', ...args);
    }
  },

  auth: (...args: unknown[]) => {
    if (isDevelopment && (DEBUG_FLAGS.AUTH || DEBUG_FLAGS.ALL)) {
      logger.info('[AUTH]', ...args);
    }
  },

  database: (...args: unknown[]) => {
    if (isDevelopment && (DEBUG_FLAGS.DATABASE || DEBUG_FLAGS.ALL)) {
      logger.info('[DATABASE]', ...args);
    }
  },

  error: (...args: unknown[]) => {
    // Always log errors in development
    if (isDevelopment) {
      logger.error('[ERROR]', ...args);
    }
  },

  warn: (...args: unknown[]) => {
    // Always log warnings in development
    if (isDevelopment) {
      logger.warn('[WARNING]', ...args);
    }
  },

  // Generic log that respects the ALL flag
  log: (...args: unknown[]) => {
    if (isDevelopment && DEBUG_FLAGS.ALL) {
      logger.info('[DEV]', ...args);
    }
  },

  // Enable/disable specific debug flags at runtime
  enable: (flag: keyof typeof DEBUG_FLAGS) => {
    DEBUG_FLAGS[flag] = true;
    logger.info(`[DEV] Enabled ${flag} logging`);
  },

  disable: (flag: keyof typeof DEBUG_FLAGS) => {
    DEBUG_FLAGS[flag] = false;
    logger.info(`[DEV] Disabled ${flag} logging`);
  },

  // Show current debug settings
  status: () => {
    console.table(DEBUG_FLAGS);
  }
};

// Make devLog available globally in development for easy runtime toggling
if (typeof window !== 'undefined' && isDevelopment) {
  (window as Window & { devLog?: typeof devLog }).devLog = devLog;
}